const getLocalStorageItem = <T>(key: string, defaultValue: T): T => {
  if (typeof window === "undefined") return defaultValue;
  try {
    return (localStorage.getItem(key) as T) || defaultValue;
  } catch {
    return defaultValue;
  }
};

export default getLocalStorageItem;
